import ResetFields from "./resetFields.service";

const resetFieldsModule = angular
  .module("app.services.resetFields", [])
  .service("ResetFields", ResetFields);

export default resetFieldsModule;



// WEBPACK FOOTER //
// ./src/services/resetFields/resetFields.module.js